module.exports = __webpack_public_path__ + "static/media/Vintagesignreproductionsign2007Enamelondrumlid_painted rust.6d1aad76.webp";